export default "__VITE_ASSET__DUjgU03m__"